
import {
  required,
  email,
  numeric,
  ipAddress,
  maxLength,
} from 'vuelidate/lib/validators';
import {
  statusFileSettlement,
  channelType,
  fileTypeData,
  dataVarcharMaxLength,
} from '../../../store/params';
import { getDate, date, showAlert } from '../../../lib/helpers';
import { defaultItem, editedItem, headers, search } from './attributes';

export default {
  validations: {
    editedItem: {
      email: {
        required,
        email,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.email == null ||
              this.errorValidation.email.length < 1)
          );
        },
      },

      sftp_username: {
        required,
        whitespace(value) {
          const pattern = /\s/;
          return !pattern.test(value);
        },
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.sftp_username == null ||
              this.errorValidation.sftp_username.length < 1)
          );
        },
      },

      status_item: { required },
      sftp_password: { required },
      sftp_port: { required, numeric },
      sftp_path: { required },

      sftp_ip_address: {
        required,
        ipAddress,
        maxLength: maxLength(dataVarcharMaxLength),
      },
    },
  },

  data: () => ({
    options: {},
    show: false,
    view: false,
    isFirstLoad: true,
    headers,
    dialog: false,
    dialogView: false,
    execute: false,
    search,
    filter: {
      email_owner: '',
    },
    editedItem,
    defaultItem,
    chanelType: '',
    editedIndex: -1,
    statusType: statusFileSettlement,
    selectedRow: '',
    dialogDelete: false,
    passwordFieldType: true,
    channelDataType: channelType,
    typeData: fileTypeData,
    filterData: [
      { label: '', field: 'empty_1', type: '' },
      { label: '', field: 'empty_2', type: '' },
      { label: '', field: 'empty_3', type: '' },
      { label: '', field: 'empty_4', type: '' },
      { label: 'Status', field: 'status', type: 'select', items: statusFileSettlement },
    ],
    filterValue: { email_owner: '' },
    filterConfig: [
      { key: 'email_owner', type: 'textfield', props: { label: 'Email Pemilik Usaha' } },
    ]
  }),

  computed: {
    usernameErrors() {
      const errors = [];
      if (!this.$v.editedItem.sftp_username.$dirty) {
        return errors;
      }
      if (!this.$v.editedItem.sftp_username.required)
        errors.push('User Account required.');
      if (!this.$v.editedItem.sftp_username.whitespace)
        errors.push("Can't contain whitespace.");
      if (!this.$v.editedItem.sftp_username.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.sftp_username != null
        ) {
          this.errorValidation.sftp_username.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },

    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      if (!this.$v.editedItem.email.email) errors.push('Must be valid e-mail');
      if (!this.$v.editedItem.email.required) errors.push('E-mail is required');
      if (!this.$v.editedItem.email.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.email != null
        ) {
          this.errorValidation.email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      if (errors == '') {
        this.executeData(false);
      } else {
        this.executeData(true);
      }

      return errors;
    },

    passwordErrors() {
      const errors = [];
      if (!this.$v.editedItem.sftp_password.$dirty) return errors;
      if (!this.$v.editedItem.sftp_password.required)
        errors.push('Password sftp is required');
      return errors;
    },

    sftpportErrors() {
      const errors = [];
      if (!this.$v.editedItem.sftp_port.$dirty) return errors;
      if (!this.$v.editedItem.sftp_port.required)
        errors.push('SFTP port is required');
      if (!this.$v.editedItem.sftp_port.numeric)
        errors.push('SFTP port must have numeric character');
      return errors;
    },

    sftppathErrors() {
      const errors = [];
      if (!this.$v.editedItem.sftp_path.$dirty) return errors;
      if (!this.$v.editedItem.sftp_path.required)
        errors.push('SFTP path is required');
      return errors;
    },

    statusErrors() {
      const errors = [];
      if (!this.$v.editedItem.status_item.$dirty) return errors;
      if (!this.$v.editedItem.status_item.required)
        errors.push('Status is required');
      return errors;
    },

    ipAddressErrors() {
      const errors = [];
      if (!this.$v.editedItem.sftp_ip_address.$dirty) return errors;
      if (!this.$v.editedItem.sftp_ip_address.ipAddress)
        errors.push('Must be a valid SFTP IP address');
      if (!this.$v.editedItem.sftp_ip_address.required)
        errors.push('SFTP IP Address is required');
      if (!this.$v.editedItem.sftp_ip_address.maxLength)
        errors.push(
          `SFTP IP Address can't more than ${dataVarcharMaxLength} character`
        );

      if (errors == '') this.executeData(false);
      else this.executeData(true);

      return errors;
    },

    formTitle() {
      let data = '';
      if (this.editedIndex !== -1) {
        if (this.editedIndex === -2) {
          data = 'View Data Settlement Report';
        } else {
          data = 'Edit Data Settlement Report';
        }
      }
      return data;
    },

    allDataList() {
      return this.$store.state.fileSettlement.allData;
    },

    flashError: {
      get() {
        return this.$store.state.fileSettlement.flashError;
      },
      set() {
        this.$store.commit('fileSettlement/setFlashErrorMessage', '');
      },
    },

    flashErrorMessage() {
      return this.$store.state.fileSettlement.flashErrorMessage;
    },

    errorValidation() {
      return this.$store.state.fileSettlement.errors;
    },

    errorExecute() {
      return !this.execute;
    },

    loading() {
      return this.$store.state.fileSettlement.loading;
    },

    itemData() {
      return this.$store.state.fileSettlement.item.data.data;
    },

    totalData() {
      return this.$store.state.fileSettlement.totalData;
    },

    totalPage() {
      return this.$store.state.fileSettlement.totalPage;
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        this.close();
      }
    },
    dialogDelete(val) {
      if (!val) {
        this.closeDelete();
      }
    },
    options: {
      handler() {
        this.getDatasettlement();
      },
      deep: true,
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
  },

  async mounted() {
    this.$store.commit('fileSettlement/clearData');
  },

  methods: {
    updateSearch(newSearch) {
      this.search.email_owner = newSearch.email_owner || '';
      this.options.page = 1;
      this.getDatasettlement(); 
    },
    showType(newSearch) {
      this.search.email_owner = newSearch.email_owner || '';
      this.options.page = 1;
      this.getDatasettlement(); 
   
    },
    onChange(event) {
      if (event.target.value === 'SFTP') this.execute = false;
      if (event.target.value === 'Email') this.execute = false;
    },

    showData() {
      this.getDatasettlement();
    },

    resetUniqueValidation() {
      this.$store.commit('fileSettlement/clearErrors');
    },

    resetData() {
      this.search.email_owner = '';
      this.getDatasettlement();
    },

    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.email_owner = '';
      this.$nextTick(() => {
        this.getDatasettlement();
      });
    },

    getDatasettlement() {
      this.$store.commit('fileSettlement/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('fileSettlement/getDataList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    close() {
      this.resetUniqueValidation();
      this.dialogView = false;
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    executeData(data) {
      this.execute = data;
      return this.execute;
    },

    viewItem(item) {
      const newItem = { ...item, report: { id: item.id } };
      this.editedIndex = this.$store.state.fileSettlement.allData.indexOf(item);
      this.editedItem = { ...newItem };
      this.view = true;
      this.editedIndex = -2;
      this.dialogView = true;
    },

    async editItem(item) {
      this.view = false;

      if (item.channel_type === 'Email') {
        if (item.email == null) this.executeData(true);
        else this.executeData(false);
      }

      if (item.channel_type === 'SFTP') {
        if (item.email == null) this.executeData(false);
        if (item.channel_type == null) {
          this.executeData(true);
        } else {
          this.executeData(false);
        }
      }

      const newItem = { ...item, report: { merchant: item.name, id: item.id } };
      this.editedIndex = this.$store.state.fileSettlement.allData.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialog = true;

      await this.$store.dispatch('fileSettlement/viewSettlement', {
        id: newItem.id,
        date,
      });
    },

    deleteItem(item) {
      const newItem = { ...item, report: { id: item.id } };
      this.editedIndex = this.$store.state.fileSettlement.allData.indexOf(item);
      this.editedItem = newItem;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await this.$store
        .dispatch('fileSettlement/deleteSettlement', {
          date,
          report: this.editedItem,
        })
        .then((status) => {
          if (status) {
            this.closeDelete();
            showAlert(
              this.$store,
              'Delete data success !',
              'mdi-check-circle',
              'green'
            );
            this.getDatasettlement();
          } else {
            this.closeDelete();
            showAlert(
              this.$store,
              'Error on delete data !',
              'mdi-alert',
              'red'
            );
          }
        });
    },

    async saveData() {
      this.resetUniqueValidation();
      this.$store.commit('fileSettlement/setFlashErrorMessage', '');
      if (this.editedItem.channel_type === 'SFTP') {
        this.$v.editedItem.sftp_ip_address.$touch();
        this.$v.editedItem.sftp_port.$touch();
        this.$v.editedItem.sftp_username.$touch();
        this.$v.editedItem.sftp_password.$touch();
        this.$v.editedItem.sftp_path.$touch();
        this.$v.editedItem.status_item.$touch();
        if (
          !this.$v.editedItem.sftp_ip_address.$invalid &&
          !this.$v.editedItem.sftp_port.$invalid &&
          !this.$v.editedItem.sftp_username.$invalid &&
          !this.$v.editedItem.sftp_password.$invalid &&
          !this.$v.editedItem.sftp_path.$invalid &&
          !this.$v.editedItem.status_item.$invalid
        ) {
          this.getExcecuteData();
        }
      }

      if (this.editedItem.channel_type === 'Email') {
        this.$v.editedItem.email.$touch(); // val individu
        this.$v.editedItem.status_item.$touch();
        if (
          !this.$v.editedItem.email.$invalid &&
          !this.$v.editedItem.status_item.$invalid
        ) {
          this.getExcecuteData();
        }
      }
    },

    async getExcecuteData() {
      const report = this.editedItem;
      await this.$store
        .dispatch('fileSettlement/updateSettlement', {
          date,
          report,
          index: this.editedIndex,
        })
        .then((status) => {
          if (status) {
            this.close();
            showAlert(
              this.$store,
              'Update data success !',
              'mdi-check-circle',
              'green'
            );
            this.getDatasettlement();
          } else {
            showAlert(
              this.$store,
              'Error on update data !',
              'mdi-alert',
              'red'
            );
          }
        });
    },

    getDate,
  },
};